import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Report from "./Report";
import CRM from "./CRM";
import "./styles.css";
import ZRMLogo from '../src/ZRM_logo.png';

const API_BASE = process.env.REACT_APP_API_BASE;
const ZOHO_REDIRECT_URI = process.env.REACT_APP_ZOHO_REDIRECT_URI || 'https://healthchecker.zrm.dk/oauth/callback';
const scope = process.env.REACT_APP_ZOHO_SCOPE;
const client_id = process.env.REACT_APP_CLIENT_ID;

export default function App() {
  const [generationStarted, setGenerationStarted] = useState(false);
  const [reportEmail, setReportEmail] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const popupRef = useRef(null);

  const startOAuth = async () => {
    const state = "start";
    const redirectUri = ZOHO_REDIRECT_URI;

    popupRef.current = window.open(
      `https://accounts.zoho.eu/oauth/v2/auth?response_type=code&client_id=${client_id}&scope=${encodeURIComponent(scope)}&redirect_uri=${encodeURIComponent(redirectUri)}&access_type=offline&prompt=consent&state=${encodeURIComponent(state)}`,
      "ZohoOAuth",
      "width=600,height=700"
    );

    return new Promise((resolve, reject) => {
      if (!popupRef.current) {
        reject(new Error("Popup blocked"));
        return;
      }

      const cleanup = () => {
        clearInterval(timer);
        window.removeEventListener("message", handleMessage);
      };

      const timer = setInterval(() => {
        if (popupRef.current.closed) {
          cleanup();
          resolve(false); 
        }
      }, 500);

      const handleMessage = async (event) => {
        const allowedOrigins = [
          window.location.origin,
          'https://healthchecker.zrm.dk',
          'https://healthchecker-30041452713.development.catalystappsail.eu',
          'https://healthchecker-30041452713.catalystappsail.eu/',
          'http://localhost:5000'
        ];
        if (!allowedOrigins.includes(event.origin)) return;

        let data;
        try {
          data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        } catch(e) {
          return;
        }

        if (data?.type === "zoho-auth-success") {
          cleanup();
          sessionStorage.setItem('apiToken', data.token);
          setReportEmail(data.email);
          setLoggedIn(true);
          resolve(true);
        }
      };


      window.addEventListener("message", handleMessage);
    });
  };


  const startBackendRun = async () => {
    const res = await fetch(API_BASE + "/bulk-read", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-api-token": sessionStorage.getItem('apiToken'),
      },
      body: JSON.stringify({
        email: reportEmail,
      }),
    });
    if (!res.ok) throw new Error("bulk-read failed");
  };

const redirectTimeoutRef = useRef(null);

const onLogin = async () => {
  try {
    await startOAuth();
  } catch (e) {
  }
};

const generateReport = async () => {
  setGenerationStarted(true);
  try {
    await startBackendRun();
    redirectTimeoutRef.current = setTimeout(() => {
      window.location.href = "https://zrm.dk/";
    }, 3000);
  } catch (e) {
  }
}

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

useEffect(() => {
  return () => {
    if (redirectTimeoutRef.current) {
      clearTimeout(redirectTimeoutRef.current);
    }
  };
}, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div className="landing">
              <header className="landing-header">
                <a href="https://zrm.dk">
      <img fetchpriority="high" width="100" src="https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1.png" 
        className="attachment-full size-full wp-image-5631" alt="ZRM logo mørk" 
        srcSet="https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1.png 6329w, https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1-300x89.png 300w, https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1-1024x305.png 1024w, https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1-768x229.png 768w, https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1-1536x457.png 1536w, https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1-2048x610.png 2048w, https://zrm.dk/wp-content/uploads/2024/11/Logo_dark-e1727709595774-1-1568x467.png 1568w" 
        sizes="(max-width: 6329px) 100vw, 6329px" />
        </a>
                <div className="topBanner">
                  <h1> Health Checker</h1>
                </div>
                {generationStarted && (
                  <div className="generation-status">
                    <h2>Report generation started</h2>

                    <p>
                      The report generation has started.<br />
                      You will receive an email at {reportEmail} when the analysis is complete.
                    </p>

                    <p className="generation-note">
                      Redirecting you to zrm.dk
                    </p>
                  </div>
                )}
                <p className="landing-subtitle">
                  Get a clear overview of your Zoho CRM data quality - in minutes.<br></br> You have to allow popups to log in.
                </p>
              </header>
              {loggedIn && !generationStarted && (
                <div className="report-email-section"> 
                  <p>The report will be sent to:</p>
                    <div className="report-generate-section">
                    <input
                      type="email"
                      placeholder="Enter email to send report to"
                      value={reportEmail}
                      onChange={(e) => setReportEmail((e.target.value).trim().toLowerCase())}
                      className="report-email-input"
                    />
                    <button
                      className="cta-button"
                      disabled={!isValidEmail(reportEmail)}
                      onClick={generateReport}
                    >
                      Generate Report
                    </button>
                  </div>
                  {!isValidEmail(reportEmail) && (
                      <div className="error-stext">
                        Please enter a valid email address
                      </div>
                    )}
                </div> 
                )}
              {!loggedIn && (
                <section className="landing-cta">
                  <button className="cta-button" onClick={onLogin}>
                    Log in with Zoho CRM
                  </button>

                  <p className="cta-note">
                    Read-only access. No data is modified.
                  </p>
                </section>
              )}
              <section className="landing-features">
                <ul>
                  <li>Duplicate records across Accounts, Contacts and Leads</li>
                  <li>Count of overdue Tasks</li>
                  <li>Empty records and missing activity</li>
                  <li>Workflow insights</li>
                </ul>
              </section>
              {/* Fixed Footer */}
              <div className="footer">
                <p>Powered by </p>
                <img
                  src={ZRMLogo}
                  alt="Powered by ZRM"
                  style={{
                    maxWidth: "50px",
                    height: "auto",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
              </div>
            </div> 
            
          }
        />
        <Route path="/report" element={<Report />} />
        <Route path="/crm" element={<CRM />} />
      </Routes>
    </BrowserRouter>
  );
}
